import { createSelector } from '@reduxjs/toolkit';

export const selectAuth = state => state.auth;

export const selectAuthUser = createSelector(
  [selectAuth],
  auth => auth.user,
);

export const selectAuthToken = createSelector(
  [selectAuth],
  auth => auth.token,
);

export const selectAuthLoading = createSelector(
  [selectAuth],
  auth => auth.loading,
);
